import ScopeConstants from "constants/ScopeConstants"
import { FormActionReducer } from "@gman/gman-redux"

export const ProjectSummaryManagerReducer = (
    state = {
        ...FormActionReducer.defaultPageState(),
        ...FormActionReducer.defaultSearchOptions("ProjectName", 10, true),
        ...FormActionReducer.defaultRecordState(),
        ...FormActionReducer.defaultTabs()
    },
    action) => {
    if (action.scope === ScopeConstants.PROJECT_SUMMARY_MANAGER) {
        if (action.type === "CHANGE_PAGE_SIZE") {
            return {
                ...state,
                searchOptions: {
                    ...state.searchOptions,
                    pageSize: action.pageSize
                }
            }
        }
        return FormActionReducer.reduce(action, state)
    }
    return state
}